module.exports = __webpack_public_path__ + "img/dress-potrait.2db97500.png";